import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Route guard. Redirects unauthenticated users to /login and users with an
 * unverified email to /verify-email. Renders nested routes otherwise.
 */
export function RequireAuth() {
  const { user, loading, emailVerified } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen text-[#999999]">
        <Loader2 size={28} className="animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (!emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  return <Outlet />;
}
